import { endPoints } from "../../constant/api_constants/url";
import { API_METHODS } from "../../enums";
import { fetchApi } from "../../utils/apiFunction";

export const getConfig = async (accessJWT: string) => {
  const endpoint = endPoints.config;
  if (!accessJWT) return null;
  return await fetchApi(accessJWT, endpoint, API_METHODS.GET);
};

export const getConfigWithFilter = async (accessJWT: string, filterCategory: string, skip: number, limit: number) => {
  const endpoint = endPoints.configFilter;
  if (!accessJWT) return null;
  return await fetchApi(accessJWT, endpoint, API_METHODS.POST, { category: filterCategory, skip, limit });
};
